import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

import { ISubSection, IVideo } from '../../../typings/hlroom';
import styles from '../../../utils/styles';
import TypograpyHeadingComponent from '../../foundation/typography/typography-heading/typography-heading';
import LoadMoreButton, {
  LOAD_MORE_SIZE_MEDIUM,
  LOAD_MORE_SIZE_LARGE,
} from '../../atoms/load-more-button/load-more-button';

import { mapVideoToCard, mapVideoToCardIsMenuOpen } from './helpers/mapVideoToCard';

import './CardsList.scss';

export interface ICardsList {
  title: string;
  subSection?: ISubSection;
  videos: IVideo[];
  isDesktop: boolean;
  itemsNumber?: number;
  loadMoreFn?: (videosLimit?: number, videosStep?: number) => void;
  videosTotal?: number;
  videosStep?: number;
  navFilterallVisibility: boolean;
  appType?: string;
}

const CardsList: React.FC<ICardsList> = ({
  title,
  subSection,
  videos,
  isDesktop,
  loadMoreFn,
  videosTotal = 0,
  videosStep = 4,
  navFilterallVisibility,
  appType,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(!appType);
  const [videosLimit, setVideosLimit] = useState<number>(videosStep);

  useEffect(() => {
    setIsMenuOpen(!appType ? isDesktop && Boolean(subSection?.tag) : false);
  }, [isDesktop, subSection]);

  const incVideosLimit = () => {
    setVideosLimit(videosLimit + videosStep);
  };

  return (
    <div className={styles('cards-list')}>
      <span className={styles('cards-list__title', isDesktop && appType !== 'tg24' && 'cards-list__title--uppercase')}>
        {videos.length > 0 && appType !== 'tg24' && <TypograpyHeadingComponent text={title} headingTag="h2" />}
        {videos.length > 0 && appType === 'tg24' && (
          <TypograpyHeadingComponent text={title} customFont="ty-heading-tg24--s" headingTag="h2" />
        )}
      </span>

      {loadMoreFn && !isDesktop ? (
        <InfiniteScroll
          next={loadMoreFn}
          hasMore={videos.length < videosTotal}
          dataLength={videos.length}
          loader={<span />}
          style={{ overflow: 'initial' }}
          className={styles('cards-list__content', isMenuOpen && 'cards-list__content--flex')}
        >
          {videos.map((video) => mapVideoToCard(video, navFilterallVisibility, appType))}
        </InfiniteScroll>
      ) : (
        <div className={styles('cards-list__content', isMenuOpen && 'cards-list__content--flex')}>
          {videos
            .slice(0, videosLimit)
            .map((video) =>
              isMenuOpen
                ? mapVideoToCardIsMenuOpen(video, appType)
                : mapVideoToCard(video, navFilterallVisibility, appType)
            )}
        </div>
      )}

      {loadMoreFn && isDesktop && videosLimit < videosTotal && (
        <div className={styles(isMenuOpen && 'cards-list__content--flex cards-list__content')}>
          <div className={styles(isMenuOpen && 'card--row card')}>
            <div
              className={styles('cards-list__load-more-wrapper', isMenuOpen && 'cards-list__load-more-wrapper--ismenu')}
            >
              <LoadMoreButton
                size={isMenuOpen ? LOAD_MORE_SIZE_MEDIUM : LOAD_MORE_SIZE_LARGE}
                onClick={() => {
                  loadMoreFn(videosLimit, videosStep);
                  incVideosLimit();
                }}
              />
            </div>
            {isMenuOpen && <div className={styles('cards-list__load-more-wrapper-sibling')} />}
          </div>
        </div>
      )}
    </div>
  );
};

export default CardsList;
